export default {
  NOT_OPENED: 'not_opened',
  OPENED: 'opened',
  ANSWERED: 'answered',
};
